import {Component} from '@angular/core';

import {SharedModule} from '../../../../../../shared/shared.module';
import {DialogMsgSupplier, Paragraphe} from '../../../../../../core/suppliers/dialog-msg-supplier';
import {HELP_FOLDERS} from '../../../../../../core/constants';

@Component({
  selector: 'yo-dialog-change-unite-technique-help',
  templateUrl: './dialog-change-unite-technique-help.component.html',
  standalone: true,
  imports: [
    SharedModule
  ]
})
export class DialogChangeUniteTechniqueHelpComponent {

  pathFile: string = HELP_FOLDERS.PRODUITS + '/produits-declinaison-changement-unite-technique';

  dialogMsgSupplier = (): DialogMsgSupplier => {
    let dms = new DialogMsgSupplier();
    dms.title = `Changement de l'unité technique`;
    dms.logo = 'fa fa-question-circle  yoni-color';

    let p1: Paragraphe = new Paragraphe();
    p1.title = ``;
    p1.lines = [
      `Cette action va permettre de changer l'unité technique d'une denrée.`,
      `Ce changement aura un impact sur la recette d'un plat utilisant cette denrée`,
      `Le grammage de la recette ne va pas changer. Mais le nombre d'unité technique`,
      `utilisé necessaire pour réaliser la recette peut changer en fonction du`,
      `pourcentage de subtitution.`
    ];

    dms.content = {
      intro: `Unité technique`,
      paragraphes: [p1]
    };

    return dms;
  };
}
